export default __webpack_public_path__ + "download-full-btn-plp-oZL.svg";